module.exports = __webpack_public_path__ + "img/zlpg.3fb5efc.png";